import _classCallCheck from "/home/node/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { glob } from './Global.js';
import { Util } from './Util.js';
var now = function () {
  if (glob.performance && glob.performance.now) {
    return function () {
      return glob.performance.now();
    };
  }
  return function () {
    return new Date().getTime();
  };
}();
export var Animation = /*#__PURE__*/function () {
  function Animation(func, layers) {
    _classCallCheck(this, Animation);
    this.id = Animation.animIdCounter++;
    this.frame = {
      time: 0,
      timeDiff: 0,
      lastTime: now(),
      frameRate: 0
    };
    this.func = func;
    this.setLayers(layers);
  }
  _createClass(Animation, [{
    key: "setLayers",
    value: function setLayers(layers) {
      var lays = [];
      if (!layers) {
        lays = [];
      } else if (layers.length > 0) {
        lays = layers;
      } else {
        lays = [layers];
      }
      this.layers = lays;
      return this;
    }
  }, {
    key: "getLayers",
    value: function getLayers() {
      return this.layers;
    }
  }, {
    key: "addLayer",
    value: function addLayer(layer) {
      var layers = this.layers,
        len = layers.length,
        n;
      for (n = 0; n < len; n++) {
        if (layers[n]._id === layer._id) {
          return false;
        }
      }
      this.layers.push(layer);
      return true;
    }
  }, {
    key: "isRunning",
    value: function isRunning() {
      var a = Animation,
        animations = a.animations,
        len = animations.length,
        n;
      for (n = 0; n < len; n++) {
        if (animations[n].id === this.id) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "start",
    value: function start() {
      this.stop();
      this.frame.timeDiff = 0;
      this.frame.lastTime = now();
      Animation._addAnimation(this);
      return this;
    }
  }, {
    key: "stop",
    value: function stop() {
      Animation._removeAnimation(this);
      return this;
    }
  }, {
    key: "_updateFrameObject",
    value: function _updateFrameObject(time) {
      this.frame.timeDiff = time - this.frame.lastTime;
      this.frame.lastTime = time;
      this.frame.time += this.frame.timeDiff;
      this.frame.frameRate = 1000 / this.frame.timeDiff;
    }
  }], [{
    key: "_addAnimation",
    value: function _addAnimation(anim) {
      this.animations.push(anim);
      this._handleAnimation();
    }
  }, {
    key: "_removeAnimation",
    value: function _removeAnimation(anim) {
      var id = anim.id,
        animations = this.animations,
        len = animations.length,
        n;
      for (n = 0; n < len; n++) {
        if (animations[n].id === id) {
          this.animations.splice(n, 1);
          break;
        }
      }
    }
  }, {
    key: "_runFrames",
    value: function _runFrames() {
      var layerHash = {},
        animations = this.animations,
        anim,
        layers,
        func,
        n,
        i,
        layersLen,
        layer,
        key,
        needRedraw;
      for (n = 0; n < animations.length; n++) {
        anim = animations[n];
        layers = anim.layers;
        func = anim.func;
        anim._updateFrameObject(now());
        layersLen = layers.length;
        if (func) {
          needRedraw = func.call(anim, anim.frame) !== false;
        } else {
          needRedraw = true;
        }
        if (!needRedraw) {
          continue;
        }
        for (i = 0; i < layersLen; i++) {
          layer = layers[i];
          if (layer._id !== undefined) {
            layerHash[layer._id] = layer;
          }
        }
      }
      for (key in layerHash) {
        if (!layerHash.hasOwnProperty(key)) {
          continue;
        }
        layerHash[key].batchDraw();
      }
    }
  }, {
    key: "_animationLoop",
    value: function _animationLoop() {
      var Anim = Animation;
      if (Anim.animations.length) {
        Anim._runFrames();
        Util.requestAnimFrame(Anim._animationLoop);
      } else {
        Anim.animRunning = false;
      }
    }
  }, {
    key: "_handleAnimation",
    value: function _handleAnimation() {
      if (!this.animRunning) {
        this.animRunning = true;
        Util.requestAnimFrame(this._animationLoop);
      }
    }
  }]);
  return Animation;
}();
Animation.animations = [];
Animation.animIdCounter = 0;
Animation.animRunning = false;